module.exports = __webpack_public_path__ + "img/blockS2-card5.2de466ff.svg";